function updateFeaturedCollectionViewAll(targetParent, tab) {
  const viewAllLink = targetParent?.querySelector("[data-featured-collection-view-all]");
  if (!viewAllLink || !tab) return;

  const collectionUrl = tab.dataset.collectionUrl || "";
  const viewAllLabel = tab.dataset.viewAllLabel || "";

  if (!collectionUrl) {
    viewAllLink.hidden = true;
    viewAllLink.removeAttribute("href");
    viewAllLink.removeAttribute("aria-label");
    return;
  }

  viewAllLink.hidden = false;
  viewAllLink.href = collectionUrl;

  if (viewAllLabel) {
    viewAllLink.setAttribute("aria-label", viewAllLabel);
  } else {
    viewAllLink.removeAttribute("aria-label");
  }
}

// Handle first tab on page load to prevent initial animation issues
document.addEventListener("DOMContentLoaded", () => {
  const firstTabContent = document.querySelector(".tab-content.active");
  if (firstTabContent) {
    // Remove animation classes from the first tab content to prevent initial animation issues
    const animatedElements = firstTabContent.querySelectorAll(".scroll-trigger.animate--slide-in");
    animatedElements.forEach((element) => {
      element.classList.remove("scroll-trigger", "animate--slide-in");
      element.style.transform = "none";
      element.style.opacity = "1";
    });
  }

  document.querySelectorAll(".featured-collection-container").forEach((collectionContainer) => {
    const activeTab = collectionContainer.querySelector(".tab.active");
    if (activeTab) {
      updateFeaturedCollectionViewAll(collectionContainer, activeTab);
    }
  });
});

document.querySelectorAll(".tab").forEach((tab) => {
  tab.addEventListener("click", () => {
    const refreshActiveTabSwatches = () => {
      if (typeof applyProductSwatches === "function") {
        window.requestAnimationFrame(() => {
          applyProductSwatches();
        });
      }
    };

    const target = tab.dataset.tab;
    const existingContent = document.getElementById(target);
    const template = document.getElementById(`template-${target}`);
    const targetParent = tab.closest(".featured-collection-container");

    targetParent.querySelectorAll(".tab").forEach((t) => t.classList.remove("active"));
    tab.classList.add("active");
    updateFeaturedCollectionViewAll(targetParent, tab);

    targetParent.querySelectorAll(".tab-content").forEach((c) => c.classList.remove("active"));
    if (existingContent) {
      existingContent.classList.add("active");
      refreshActiveTabSwatches();
    } else if (template) {
      const clone = template.content.cloneNode(true);
      template.parentNode.insertBefore(clone, template);
      const newContent = document.getElementById(target);
      newContent.classList.add("active");

      // Remove animation classes from newly inserted content to prevent re-animation
      const animatedElements = newContent.querySelectorAll(".scroll-trigger.animate--slide-in");
      animatedElements.forEach((element) => {
        element.classList.remove("scroll-trigger", "animate--slide-in");
        element.style.transform = "none";
        element.style.opacity = "1";
      });

      refreshActiveTabSwatches();
    }
  });
});
